var map;
function gmapLoad(latitude, longitude, zoom, setMarker, dragMarker)
{
    var latlng = new google.maps.LatLng(latitude, longitude);
    return gmapLoadLatLng(latlng, zoom, setMarker, dragMarker)
}
function gmapLoadLatLng(latlng, zoom, setMarker, dragMarker)
{
    var myOptions =
    {
        zoom: zoom,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map(
        document.getElementById("map"),
        myOptions
    );
    if (setMarker)
    {
        var marker = gmapSetMarker(map, latlng, dragMarker)
    }
    return map;
}
function gmapSetMarker(map, latlng, drag)
{
    var marker = new google.maps.Marker({
        position: latlng,
        title:"Ici"
    });
    marker.setMap(map);
    marker.setDraggable(drag);
    if (drag)
    {
        if($("#gmapLatitude").length) $("#gmapLatitude").html(latlng.lat().toFixed(5));
        if($("#gmapLongitude").length) $("#gmapLongitude").html(latlng.lng().toFixed(5));
        google.maps.event.addListener(marker, "dragend", function() {
            var point = marker.getPosition();
            map.panTo(point);
            if($("#gmapLatitude").length) $("#gmapLatitude").html(point.lat().toFixed(5));
            if($("#gmapLongitude").length) $("#gmapLongitude").html(point.lng().toFixed(5));
        });
    }
    return marker;
}

function gmapAddPointWithWindow(lat, lng, title, content)
{
    var myLatlng = new google.maps.LatLng(lat, lng);
    var contentString = '<div class="gmapWindow" id="content">'+content+'</div>';

    var infowindow = new google.maps.InfoWindow({
        //maxWidth: 200,
        disableAutoPan:false,
        content: contentString
    });
    var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        title: title
    });
    marker.setMap(map);
    google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map,marker);
    });
}
function gmapAddAddressWithWindow(city, zip, address, title, content)
{
    geocoder = new google.maps.Geocoder();
    geocoder.geocode(
        { 'address':  address+', '+zip+' '+city}, // address
        function (results, status) {
            if (status == google.maps.GeocoderStatus.OK)
            {
                place = results[0].geometry.location;
                gmapAddPointWithWindow(place.lat(), place.lng(), title, content);
                map.panTo(results[0].geometry.location);
            }
            else
            {
                gmapAddAddressWithWindowReady( zip+' '+city, title, content+'<p>(Placement approximatif)</p>')
            }
        } // callback
    );


}
function gmapAddAddressWithWindowReady(address, title, content)
{
    geocoder = new google.maps.Geocoder();
    geocoder.geocode(
        { 'address': address}, // address
        function (results, status) {
            if (status == google.maps.GeocoderStatus.OK)
            {
                place = results[0].geometry.location;
                gmapAddPointWithWindow(place.lat(), place.lng(), title, content);
                map.panTo(results[0].geometry.location);

            }
            else
            {
                //alert(('gmapCantFindAddress') + ' : ' + status);
            }
        } // callback
    );

}